export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtMena';
export const NAME = 'Mena';
